"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        paddingRight: 7,
        color: theme.grey3
    }
});
//# sourceMappingURL=textinput.suffix.style.js.map